<template>
    <AppLayout>
        <div class="container flex flex-col justify-center p-4 mx-auto md:w-3/4">
            <div class="mb-4 font-bold md:text-2xl">
                {{ isWholesaler ? 'Provide Credit' : '' }}
            </div>
            <div class="px-4 py-6 bg-white border rounded">

                <!-- Requested By (readonly for wholesaler) -->
                <div v-if="isWholesaler" class="flex flex-col mb-4 md:flex-row md:items-center md:gap-4 md:mb-2">
                    <div class="w-1/4">Provided To</div>
                    <div class="w-3/4 text-gray-800 font-semibold">
                        {{ user.name }}
                    </div>
                </div>

                <!-- Amount to Approve -->
                <div class="flex flex-col mb-4 md:flex-row md:items-center md:gap-4 md:mb-8">
                    <div class="w-1/4">
                        Approve Amount
                    </div>
                    <div class="w-3/4">
                        <t-input v-model.number="form.amount" type="number" placeholder="Amount to provided" />
                    </div>
                </div>

                <div class="flex flex-col mb-4 md:flex-row md:items-center md:gap-4 md:mb-8">
                    <div class="w-1/4">
                        Message
                    </div>
                    <div class="w-3/4">
                        <t-textarea v-model="form.message" placeholder="Message" rows="5" />
                    </div>
                </div>
                <!-- Action buttons -->
                <div class="flex items-center justify-end gap-2">
                    <Button text="Assign Credit" color="green" @onClick="submitForm" />
                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue';
import Button from '@/Components/Button.vue';
import common from '@/common';

export default {
    name: 'AssignCredit',

    components: {
        AppLayout,
        Button,
    },

    props: {
        user: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        return {
            common,
            form: {
                amount: null,
                message: null,
            },
        };
    },

    watch: {

    },

    methods: {

        submitForm() {
            const payload = this.buildPayload();
            this.save(payload);
        },

        buildPayload() {
            const formData = new FormData();
            if (this.user.id) {
                formData.append('user_id', this.user.id);
            }
            if (this.form.amount) {
                formData.append('credit_allowed', parseInt(this.form.amount));
            }
            if (this.form.message) {
                formData.append('message', this.form.message);
            }
            return formData;
        },

        save(payload) {

            this.$inertia.post(route('creditRequest.assignManualCredit'), payload);
        },
    },
};
</script>
